import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import AppBar from '../components/AppBar';
import Toolbar, { styles as toolbarStyles } from '../components/Toolbar';
import ScrollTo from 'react-scroll-into-view';

const styles = theme => ({
  title: {
    
    flexGrow: 3,
    [theme.breakpoints.up('lg')]: {
      fontSize: 24,
    },
    [theme.breakpoints.down('lg')]: {
      fontSize: 20,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: 16,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
    }
    
  },
  placeholder: toolbarStyles(theme).root,
  toolbar: {
    justifyContent: 'space-between',
  },
  left: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-start',
  },
  leftLinkActive: {
    color: theme.palette.common.white,
  },
  right: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    cursor: 'pointer'
  },
  rightLink: {
    [theme.breakpoints.up('md')]: {
      fontSize: 16,
    },   
    [theme.breakpoints.down('md')]: {
      fontSize: 12,
    },
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    textAlign: 'center',    
    color: theme.palette.common.white,    
    marginLeft: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(4),
    },
    [theme.breakpoints.down('xs')]: {
      marginLeft: theme.spacing(0),
    },
    
  },
  
  linkSecondary: {
    color: theme.palette.secondary.main,
  },
});

function AppAppBar(props) {
  const { classes } = props;
  

  return (
    <div>
      <AppBar position="fixed">
        <Toolbar className={classes.toolbar}>
          <div className={classes.left}>
            
            <Link
              variant="h6"
              underline="none"
              color="inherit"
              className={classes.title}
              href='/'
            >
              {'estudio sarasa sevillano'}
            </Link>
          </div>
          <div className={classes.right}>
            <ScrollTo className={classes.rightLink}
              style={{variant: "h6" }}
              selector={`#${'quienes'}`}
            >
              QUIENES SOMOS 
            </ScrollTo>
            <ScrollTo className={classes.rightLink}
              style={{variant: "h6" }}
              selector={`#${'servicios'}`}
            >
              SERVICIOS
            </ScrollTo>
            <ScrollTo className={classes.rightLink}
              style={{variant: "h6" }}
              selector={`#${'footer'}`}
            >
              CONTACTO
            </ScrollTo>
            <Link
              variant="h6"
              underline="none"
              className={clsx(classes.rightLink, classes.linkSecondary)}
              href='/ingresoclientes'
            >
              {'Ingreso Clientes'}
            </Link>
           
          </div>
        </Toolbar>
      </AppBar>
      <div className={classes.placeholder} />
    </div>
  );
}

AppAppBar.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AppAppBar);
